// src/components/servicepartner/ServicePartnerForm.jsx
import { useState, useEffect } from "react";
import { Box, Heading, Input, Button, VStack, Text } from "@chakra-ui/react";
import axios from "axios";
import EnergieErzeugerCheckboxes from "./EnergieErzeugerCheckboxes";
import ServicePartnerRatesForm from "./ServicePartnerRatesForm";
import ServicePartnerTechnikForm from "./ServicePartnerTechnikForm";
import ServicePartnerInfoForm from "./ServicePartnerInfoForm";

export default function ServicePartnerForm({ existingPartner = null, onSuccess }) {
  const [partner, setPartner] = useState({
    partnerName: "",
    telefon: "",
    mobilNr: "",
    email: "",
    firmenName: "",
    strasseHausnummer: "",
    plz: "",
    ort: "",
  });

  const [partnerTechnik, setPartnerTechnik] = useState({});
  const [partnerRates, setPartnerRates] = useState({});
  const [partnerInfo, setPartnerInfo] = useState({});

  useEffect(() => {
    if (existingPartner) setPartner(existingPartner);
  }, [existingPartner]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPartner((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      if (existingPartner) {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/api/service-partner/${existingPartner.id}`,
          partner
        );
        alert("Service-Partner aktualisiert!");
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/service-partner`, partner);
        alert("Service-Partner angelegt!");
      }
      onSuccess?.();
    } catch (err) {
      console.error(err);
      alert("Fehler beim Speichern.");
    }
  };

  const handleCheckbox = (e) => {
    const { value, checked } = e.target;

    let selected = partner.energieErzeuger
      ? partner.energieErzeuger.split(",")
      : [];

    if (checked) {
      selected.push(value);
    } else {
      selected = selected.filter((v) => v !== value);
    }

    setPartner((prev) => ({
      ...prev,
      energieErzeuger: selected.join(","),
    }));
  };

  return (
    <Box maxW="4xl" mx="auto" mt={10} p={8} bg="white" borderRadius="xl" boxShadow="lg">
      <Heading size="md" mb={6} color="blue.600">
        {existingPartner ? "Service-Partner bearbeiten" : "Neuen Service-Partner anlegen"}
      </Heading>

      <VStack align="stretch" spacing={4}>
        <Text fontWeight="semibold">Partnername</Text>
        <Input name="partnerName" value={partner.partnerName} onChange={handleChange} />

        <Text fontWeight="semibold">Telefon</Text>
        <Input name="telefon" value={partner.telefon} onChange={handleChange} />

        <Text fontWeight="semibold">Mobil-Nr.</Text>
        <Input name="mobilNr" value={partner.mobilNr} onChange={handleChange} />

        <Text fontWeight="semibold">E-Mail</Text>
        <Input name="email" value={partner.email} onChange={handleChange} />

        <Text fontWeight="semibold">Firmenname</Text>
        <Input name="firmenName" value={partner.firmenName} onChange={handleChange} />

        <Text fontWeight="semibold">Strasse / Hausnummer</Text>
        <Input name="strasseHausnummer" value={partner.strasseHausnummer} onChange={handleChange} />

        <Text fontWeight="semibold">PLZ</Text>
        <Input name="plz" value={partner.plz} onChange={handleChange} />

        <Text fontWeight="semibold">Ort</Text>
        <Input name="ort" value={partner.ort} onChange={handleChange} />

        <Button colorScheme="blue" onClick={handleSubmit} alignSelf="flex-start">
          {existingPartner ? "Aktualisieren" : "Anlegen"}
        </Button>

        <EnergieErzeugerCheckboxes
          partner={partner}
          setPartner={setPartner}
          handleCheckbox={handleCheckbox}
        />

        <ServicePartnerRatesForm
          partnerRates={partnerRates}
          setPartnerRates={setPartnerRates}
        />

        <ServicePartnerTechnikForm
          partnerTechnik={partnerTechnik}
          setPartnerTechnik={setPartnerTechnik}
        />

        <ServicePartnerInfoForm
          partnerInfo={partnerInfo}
          setPartnerInfo={setPartnerInfo}
        />

      </VStack>
    </Box>
  );
}